<img (click)="visualiser()" [src]="calculateUrl(block)"/>

